import { Antwoord, Vraag, VraagMail, AntwoordMail } from '@models/claims';
import { VraagboomAntwoord, VraagboomEmptyResultaat } from '@models/vragenboom';

export class MultiChoiceMapper {
  public static mapResultaten(vraagboomAntwoord: VraagboomAntwoord<VraagboomEmptyResultaat>, vragen: Vraag[]) {
    if (vraagboomAntwoord == null || vragen == null) {
      return;
    }

    const vraag: Vraag = new Vraag();
    if (vraagboomAntwoord.vraag != null) {
      vraag.id = vraagboomAntwoord.vraag.id;

      if (vraagboomAntwoord.antwoorden != null) {
        for (const antwoord of vraagboomAntwoord.antwoorden) {
          vraag.antwoorden.push(new Antwoord({ id: antwoord.id }));
        }
      }

      vragen.push(vraag);
    }
  }

  public static mapResultatenMail(vraagboomAntwoord: VraagboomAntwoord<VraagboomEmptyResultaat>, vragen: VraagMail[]) {
    if (vraagboomAntwoord == null || vragen == null) {
      return;
    }

    const vraag: VraagMail = new VraagMail;

    if (vraagboomAntwoord.vraag != null) {
      vraag.vraagtitel = vraagboomAntwoord.vraag.titel;
    }

    if (vraagboomAntwoord.antwoorden != null) {
      for (const antwoord of vraagboomAntwoord.antwoorden) {
        vraag.antwoorden.push(new AntwoordMail({ antwoordtitel: antwoord.titel }));
      }
    }

    vragen.push(vraag);
  }
}
